import styled from '@emotion/styled';

import { Breakpoints } from '../../../styles/variables/breakpoints';

const { sm } = Breakpoints;

export const StyledChatPageNew = styled.div`
    height: calc(100vh - 80px);
    justify-content: center;
    align-items: center;
    background: #ffffff;
    margin-top: 80px;
    display: flex;
`;

export const StyledChatContainerNew = styled.div`
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    max-width: 1256px;
    overflow: hidden;
    display: flex;
    height: 100%;
    width: 100%;

    @media (max-width: ${sm}) {
        justify-content: center;
    }
`;
